import { render, staticRenderFns } from "./MoneyWidget.vue?vue&type=template&id=11fbe344"
import script from "./MoneyWidget.vue?vue&type=script&lang=js"
export * from "./MoneyWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports